export default {
  namespaced: true,
  custom_forms: {
    select_tenant: "Selecione um tenant",
    select_users: "Seleciona usuários",
    select_user_group: "seleciona grupos de usuários",
    select_user: "Selecione um usuário",
    select_facility: "Selecione uma instalações",
    select_facility_category: "Selecione uma categoria de instalação",
    select_related_forms: "Selecione formulários relacionados",
    prefill_template: "É um formulário de pré-inscrição.",
    requires_prefill: "Requer pré-inscrição.",
    is_mailable: "Pode ser enviado por e-mail",
    display_in_alarm: "Exibir em um menu de alarmes",
    is_horizontal: "Exibir o formulário na horizontal",
    is_cheker_maker: "Requer aprovação",
    allow_draft: "Permitir salvar como rascunho",
    types: {
      title: 'type | types',
      select: "Opção Múltipla",
      checkbox: "Caixas de Seleção",
      text_answer: "Resposta de Texto",
      files_section: "Seção de arquivos",
      inputGroup: "Grupo de inputs",
      commands: "Comandos",
      inputText: "Texto de entrada",
      users: "Usuário",
      rh_users: "Usuários RH",
      units: "Unidade",
      facilities: "Instalação",
      placeholder: "Placeholder",
      facility_category: "Categoria da instalação",
      date: "Data",
      time: "Hora",
      minutes: "Minutos",
      time_hhmm: "Hora (HH:MM)",
      duration_hm: "Duração (horas e minutos)",
      duration_ms: "Duração (minutos e segundos)",
      duration_hms: "Duração (horas, minutos e segundos)",
      numeric: "Numérico",
      classification: "Classificação",
      distribution_lists: "Listas de distribuição",
      subject: "Assunto",
      recipient: "Destinatário",
      email: "E-mail",
      related_forms: "Formulários relacionados",
      local_time: "Hora local",
      central_time: "Hora central",
      user_list: "Lista de usuários",
      keyword: "Palavra-chave",
      folio: "Fólio",
      region: "Região",
      timestamp: "Marca de tempo",
      device_doc: "Documentação de dispositivos",
      supplier: "Fornecedor",
      technicians: "Técnicos",
    },
    allow_comment: "Permitir comentário",
    select_multiple: "Selecionar vários",
    selecting_multiple: "Selecionando...",
    clean: "Limpar",
    send_to_review: "Enviar para revisão",
    reopen: "Reabrir formulario",
    state: "Estado",
    user: "Usuário",
    user_group: "Grupo de usuário",
    date: "Data",
    note: "Nota",
    empty: "Sem movimentações",
    show_less: "Mostrar menos",
    show_all: "Mostrar todo o histórico",
    btn_reassign: "Reatribuir",
    close: "Fechar",
    entries: "Entradas",
    history: "Histórico",
    select_reviewer: "Seleciona usuário revisor",
    cannot_start_form: "Não foi possível iniciar o formulário",
    update_state_error: "Não foi possível atualizar o estado",
    answers_saved: "Respostas salvas",
    reassign: "Reatribuir",
    select_reassigner: "Seleciona usuário para reatribuir",
    assigned_to: "Designar responsável",
    assigned_to_reopen: "Designar responsável pela reabertura",
    reassigned_to: "Reasignar responsable",
    review_comments: "Comentários da revisão",
    content: "conteúdo",
    placeholder_tooltip: "será substituído por valores reais quando enviado.",
    generate_keyword: "Gerar palavra-chave",
    maxlength: "Número máximo de caracteres",
    maxlengthSelect: "Número máximo de itens a selecionar",
    hint: "Texto de ajuda",
    date_format: "Formato de data",
    generate_timestamp: "Clique para gerar marcação de tempo",
    check_facility_fields: "Marque quais campos adicionais devem aparecer.",
    categories: "Categorias",
    subregion: "Sub-região",
    id_seproban: "ID SEPROBAN",
    municipality: "Município",
    region_field: "Estado",
    sirh: "SIRH",
    rems: "REMS",
    read_only: "Somente leitura",
    maximun_amount: "Quantidade máxima que você pode selecionar",
    type_number: "Tipo número",
    no_extra_config: "Não há configuração adicional para este tipo de campo",
    lat: "Latitude",
    lng: "Comprimento",
    read_only_users: "Usuários somente leitura",
    only_img: "Apenas imagens",
    show_empty: "Mostrar vazio",
    read_only_users: "Usuários somente leitura",
    significant_event: "Evento relevante",
    significant_event_title: "Titulo del evento",
    significant_event_description: "Descripcion del evento",
    significant_event_regional_manager: "Diretor de seguridad em funções",
    security_manager: "Diretor de seguridad",
    excluded_atms: "Excluir ATMs",
  },
};
